
import { useI18n } from 'vue-i18n';
import Loading from '@/components/Loading.vue';
import SadButton from '@/components/sad/SadButton.vue';
import { getMe, updateAuthToken } from '@/repositories/auth';
import { useAuth0 } from '@auth0/auth0-vue';
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import alert from '@/support/alert';

export default defineComponent({
  name: 'Auth',

  components: {
    Loading,
    SadButton,
  },

  setup() {
    const router = useRouter();
    const { t } = useI18n();
    const { loginWithPopup, isAuthenticated, getAccessTokenSilently } =
      useAuth0();
    const isLoading = ref(isAuthenticated.value);

    const getTokensAndGoToBudget = async () => {
      const token = await getAccessTokenSilently();

      updateAuthToken(token);
      const currentUser = await getMe();

      router.push({
        name: 'Budget',
        params: { budgetId: currentUser.defaultBudgetId },
      });
    };

    onMounted(() => {
      if (isAuthenticated.value) {
        getTokensAndGoToBudget();
      }
    });

    const login = async () => {
      isLoading.value = true;
      try {
        await loginWithPopup();
        await getTokensAndGoToBudget();
      } catch (err) {
        isLoading.value = false;
        alert.error(err as string);
      }
    };

    return { isLoading, login, t };
  },
});
